import React, { useEffect, useState } from 'react';
import MediaRenderer from '../../../FeatureComponents/Response/MediaRenderer';
import Simple from '../../../FeatureComponents/Response/Templates/Simple';
import { loadStateSession } from '../../../FlyfishComponents/flyfishutils/utils';
interface Props {
	data: any;
	isMultiChoice?: boolean;
	shouldDisableActions?: boolean;
	handleSubmit?: Function;
	isMultiSelect?: boolean;
	isInsideCampaign: boolean;
	botImageCheck: boolean;
	index: number;
	logoImagePath?: string;
	voiceResponse?: boolean;
	langCode?: string;
	lengthArray: number;
	timeStamp: string;
	chatInput: string;
	type?: string;
	addUserResponse?: Function;
}
const WAMultiSelect = (props: Props) => {
	const { data, shouldDisableActions, handleSubmit, langCode, timeStamp } =
		props;
	let message = '';
	const arrayMessage = [];
	data.lists.items.map((each, index) =>
		arrayMessage.push(`${index + 1}.` + each.title)
	);
	message = arrayMessage.join('\n\n');
	let data2 = data.lists.items;
	useEffect(() => {
		const keyDownHandler = (event) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				const userResponse = loadStateSession('userResp');
				let userRespArray = userResponse.split(',');
				let tempArray = [];
				userRespArray.map((each) => {
					!isNaN(Number(each)) && tempArray.push(Number(each));
				});
				if (tempArray.length > 0) {
					let optionsArray = [];
					let itemsToSend = [];
					data2.map((each) => optionsArray.push(each.title));
					tempArray.forEach((item) =>
						itemsToSend.push(optionsArray[Number(item) - 1])
					);
					itemsToSend = itemsToSend.filter((each) => each !== undefined);
					if (itemsToSend.length > 0 && !shouldDisableActions) {
						handleSubmit(itemsToSend.join(', '));
						tempArray = [];
						itemsToSend = [];
						userRespArray = [];
						data2 = [];
					}
				}
			}
		};

		document.addEventListener('keydown', keyDownHandler);
		return () => {
			document.removeEventListener('keydown', keyDownHandler);
		};
	}, [data, handleSubmit]);
	return props.type === 'card' ? (
		<div className='multiselect-for-whatsapp'>
			{props.data.displayResponse ? (
				<div className='msg-server-whatsapp display-msg'>
					<Simple
						data={
							data.displayResponse +
								'<br/>' +
								'<br/>' +
								`\n\n 💡 <b>Tip</b> : Please reply with option numbers that you want to select.<i> E.g: 1,2 </i>` ||
							data.actualResponse ||
							''
						}
						isRatingTask={data.isRatingTask}
						ratingTypeId={data.ratingTypeId}
						shouldDisableActions={shouldDisableActions}
						langCode={langCode}
						timeStamp={timeStamp}
						channel={'whatsapp'}
					/>
				</div>
			) : null}
			<div className='cards-container'>
				{data && props.data.lists.items.length > 0
					? data.lists.items.map((each, index) => {
							return (
								<>
									<div className='card'>
										{each.resourceURL.indexOf('jpeg') > -1 ||
										each.resourceURL.indexOf('jpg') > -1 ? (
											<>
												<img
													src={each.resourceURL}
													className='multiselect-image'
												/>
											</>
										) : (
											<>
												<div className='multiselect-video'>
													<MediaRenderer
														name={each.title}
														url={each.resourceURL}
													/>
												</div>
											</>
										)}

										<p className='title'>
											{index + 1}. {each.title}
										</p>
										<p className='description'>{each.description}</p>
										{data && data.lists.items.length === index + 1 && (
											<p className='card-time-stamp'>{timeStamp}</p>
										)}
									</div>
								</>
							);
					  })
					: null}
			</div>
		</div>
	) : (
		<div className=' display-msg list-for-whatsapp'>
			<Simple
				data={
					data.displayResponse +
					'\n' +
					'\n' +
					message +
					`\n\n 💡 <b>Tip</b> : Please reply with option numbers that you want to select.<i> E.g: 1,2 </i>`
				}
				isRatingTask={data.isRatingTask}
				ratingTypeId={data.ratingTypeId}
				shouldDisableActions={shouldDisableActions}
				langCode={langCode}
				timeStamp={timeStamp}
				channel={'whatsapp'}
			/>
		</div>
	);
};

export default WAMultiSelect;
